module.exports = __webpack_public_path__ + "images/logos/storage-king.png";